import script from "./date-selector.vue?vue&type=script&setup=true&lang=ts"
export * from "./date-selector.vue?vue&type=script&setup=true&lang=ts"

import "./date-selector.vue?vue&type=style&index=0&id=7885201e&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7885201e"]])

export default __exports__